module.exports = __webpack_public_path__ + "img/p2-mobile.e671f67e.png";